<div class="location-tree-container" [ngClass]="actionCenter ? 'container' : ''">
	<div class="header">
		<au-search-input
			class="m-b-sxs p-l-sm p-r-sm"
			placeholder="{{ 'type_building_name' | translate }}"
			(click)="$event.stopPropagation()"
			(searchTextChanged)="updateFilteredData($event)"
			(focusChanged)="blockKeyboardMovement = $event"
			subscriptSizingMode="dynamic"
		></au-search-input>
		@if (!disableMultipleSelect) {
			<button mat-button (click)="clearSelections()">{{ 'clear' | translate }}</button>
		}
	</div>
	@for (location of filteredLocations(); track location) {
		<!--Building level-->
		<div>
			<location-tree-node
				[locationNode]="location"
				[level]="0"
				[disabledCheckboxes]="disableMultipleSelect"
				[active]="isActive(location)"
				(locationSelected)="updateSelectedLocations($event)"
				[ngClass]="isActive(location) ? 'active' : ''"
				[disableNestedSelection]="disableNestedSelection()"
				[allowDeselectForSingleSelect]="allowDeselectForSingleSelect()"
			/>
			@if (hasChildren(location.id) && isExpanded(location.id)) {
				@for (floor of location.floor; track floor) {
					<!--Floor level-->
					<location-tree-node
						[locationNode]="floor"
						[level]="1"
						[disabledCheckboxes]="disableMultipleSelect"
						[active]="isActive(floor)"
						(locationSelected)="updateSelectedLocations($event)"
						[ngClass]="isActive(floor) ? 'active' : ''"
					/>
					@if (hasChildren(floor.id) && isExpanded(floor.id)) {
						@for (room of floor.room; track room) {
							<!--Room level-->
							<location-tree-node
								[locationNode]="room"
								[level]="2"
								[disabledCheckboxes]="disableMultipleSelect"
								[active]="isActive(room)"
								(locationSelected)="updateSelectedLocations($event)"
								[ngClass]="isActive(room) ? 'active' : ''"
							/>
						}
					}
				}
			}
		</div>
	}
</div>
